/** Created by azhou on 2019/3/20.*/
<template>
    <div>
      <public-title showBack>用户信息编辑</public-title>
      <div class="bg-white p-5">
        <div class="d-start-start mb-3">
          <left-text leftText="用户类型"  />
          <div>{{editUserItem.type | formatVar('StoreType')}}</div>
        </div>
        <left-text-border class="mb-3" leftText="姓名" v-model="editUserItem.truename"/>
        <left-text-border class="mb-3" leftText="手机号" v-model="editUserItem.mobile" disabled />
        <left-text-border class="mb-3" leftText="新手机号" v-model="editUserItem.new_mobile"/>
        <left-text-border class="mb-3" leftText="重置密码" v-model="password"/>
        <left-text-border class="mb-3" leftText="确认密码" v-model="confirmPassword"/>
        <div class="d-center-start mb-3">
          <left-text leftText="状态"/>
          <el-radio-group v-model="editUserItem.status">
            <el-radio label="1">正常</el-radio><el-radio label="0">禁用</el-radio>
          </el-radio-group>
        </div>
        <div class="d-center-start mb-3">
          <left-text leftText="清空微信"/>
          <el-radio-group v-model="wechat">
            <el-radio label="0">否</el-radio>
            <el-radio label="1">是</el-radio>
          </el-radio-group>
        </div>
        <el-button type="primary" @click="submitForm">提交修改</el-button>
      </div>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'editUser',
    computed: {
      ...mapGetters(['storeInfo']),
      queryInfo() { return this.$route.query },
    },
    data() {
      return {
        editUserItem:{},
        password:'',
        confirmPassword:'',
        wechat:'0',
      }
    },
    created() {
      this.editUserItem = this.queryInfo || {};
      this.editUserItem.status = this.editUserItem.status + '';        //状态值转字符串
    },
    methods:{
      ...mapActions(['adminEditUser']),
      submitForm() {
        if(this.editUserItem.new_mobile&&this.editUserItem.new_mobile!=''){
          if (!this.$GFUN.isPhone(this.editUserItem.new_mobile)) {
            this.$message('请填写正确的新手机号码')
            return
          }
        }
        this._confirm('确定提交修改么？',() => {
          let data = {
            uid:this.editUserItem.uid,
            truename:this.editUserItem.truename,
            mobile:this.editUserItem.mobile,
            status:this.editUserItem.status,
            type: this.editUserItem.type,
            wechat_flag:this.wechat,
            new_mobile:this.editUserItem.new_mobile
          }
          if (this.password && this.confirmPassword) {
            data.pwd = this.password;
            data.pwd2 = this.confirmPassword;
          }
          // if (this.wechat == '1') data.wechat_flag = 1;
          this.adminEditUser(data);
        })
      }
    }
  }
</script>
